import axios from "axios"
import ROOTURL from "./ROOTURL"
import { BUSINESSID } from "./ROOTURL"

export const getShippingDetails = () =>
  axios.get(`${ROOTURL}/shipping/${BUSINESSID}`)
